// Imported first, before anything else, so its `beforeinstallprompt`
// listener is attached at script-evaluation time — Chrome can fire that
// event as soon as the page loads (e.g. while the login screen is still up),
// well before any post-login component would exist to catch it otherwise.
import './lib/pwaInstallStore'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { initializeSentry } from './config/sentry.config'
import { registerServiceWorker } from './lib/registerServiceWorker'

// Initialize Sentry before rendering the app
initializeSentry();
registerServiceWorker();

createRoot(document.getElementById('root')!).render(
  <App />
)
